import BaseAction from "../base-action";
import {ActionTypeEnum} from "../../base/training-literals";

class TrackTime extends BaseAction {
    variableName;

    constructor(props = {}) {
        super(props);
        this.actionType = ActionTypeEnum.TRACK_TIME;
        this.variableName = props.variableName || "";
    }

    get(props = {}) {
        return {
            type: this.actionType,
            variableName: this.variableName,
            duration: props.duration || this.duration,
        };
    }
}

export default TrackTime;
